import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import IconButton from 'material-ui/IconButton';
// import DeleteIcon from 'material-ui/svg-icons/action/delete';


import Moment from 'react-moment';
import 'moment-timezone';
import 'moment/locale/es';

import Attach from './Attach';


// const deleteStyle = {
//     padding: '0px',
//     width: 36,
//     height: 36,
// };

let mainStyle = {
    opacity: '1',
};

let loadingStyle = {
    opacity: '0.25',
};

class Note extends Component {

    state = {
        loading: false
    };

    static propTypes = {
        id: PropTypes.number,
        item: PropTypes.object,
        newDay: PropTypes.bool,
        onDelete: PropTypes.func
    }

    onDeleteHandler = (e) => {
        if (typeof this.props.onDelete === 'function') {
            this.setState({ loading: true })
            this.props.onDelete(this);
        }
    }


    getHtml(str) {
      return {__html: str};
    }


    render() {

        const calendarStrings = {
            lastDay : '[Ayer]',
            sameDay : '[Hoy]',
            lastWeek : 'dddd D',
            sameElse : 'dddd D [de] MMMM'
        };

        const { newDay, item } = this.props;
        const { loading } = this.state;

        return (
            <div>
                {newDay &&
                    <div className="item heading">
                        <Moment calendar={calendarStrings}>{this.props.item.date}</Moment>
                    </div>
                }

                {this.props.item.task &&
                <div className="item" style={loading?loadingStyle:mainStyle}>
                    <div className="task"><strong>{item.client.name}</strong>{'.  ' + item.project.name + ' (' + item.task.midname + ')'}</div>
                    <div className={'type ' + item.type.icon} style={{color: item.type.color}}>{item.type.name}</div>
                    {/*<div className="tags">{item.tags}</div>*/}
                    <div className="description" dangerouslySetInnerHTML={this.getHtml(item.description)}></div>

                    {item.attachs &&
                        <div className="attachs">
                        {item.attachs.map((object, i) => {

                            return <Attach key={object.id} item={object} />;

                        })}
                        </div>
                    }

                    <div className="actions">
                        {/*<IconButton tooltip="Eliminar" style={deleteStyle} tooltipPosition="top-left" onClick={this.onDeleteHandler}>
                            <DeleteIcon />
                        </IconButton>*/}
                    </div>
                </div>
                }

            </div>
        );

    };

}

export default Note;


// WEBPACK FOOTER //
// ./src/modules/notes/Note.js